import { List, ListItemButton, ListItemText, ListItemIcon, ListItem, Tooltip } from '@vapor/material'
import { FC, useCallback } from 'react'
import { Link, useMatch, useNavigate } from 'react-router-dom'
import { ArrowRight } from '@mui/icons-material'
import { useMenu, MenuItem } from '../../hooks/menu/use-menu'
// import { useGrant } from 'src/app/components/authorization/grant-hooks'
// import { firstLevelPagesPermissions } from 'src/app/components/authorization/pages-permissions'

export const Menu: FC<{ onItemClick?: (menuItem?: MenuItem) => void; showTooltip?: boolean; tenantId: string; propertyId: string }> = (props) => {
  const { menu } = useMenu(props.tenantId, props.propertyId)

  return (
    <>
      <List disablePadding>
        {menu.map((menuItem, index) => (
          <MenuItemElement menuItem={menuItem} onClick={props.onItemClick} key={index} showTooltip={props.showTooltip} />
        ))}
      </List>
    </>
  )
}

const MenuItemElement: FC<{ onClick?: (menuItem?: MenuItem) => void; menuItem: MenuItem; showTooltip?: boolean }> = (props) => {
  const match = useMatch(`${props.menuItem.route}/*`)
  const navigate = useNavigate()
  // const { isGranted, isInRole } = useGrant()

  const onMenuItemClick = useCallback(
    (menuItem: MenuItem) => {
      navigate(menuItem.route)
      if (props.onClick) {
        props.onClick(menuItem)
      }
    },
    [props.onClick],
  )

  const onMenuItemClick2 = useCallback(() => {
    if (props.onClick) {
      props.onClick()
    }
  }, [props.onClick])

  // if ('page' in props.menuItem && props.menuItem.page) {
  //   const permission = firstLevelPagesPermissions.get(props.menuItem.page)

  //   if (permission && !isGranted(permission) && !isInRole(permission.permissions ?? [])) {
  //     return null
  //   }
  // }

  return (
    <Tooltip title={props.showTooltip ? props.menuItem.description : ''} placement="right">
      <span>
        <Link to={props.menuItem.route} onClick={() => onMenuItemClick2()} className="tsMainMenuLink">
          <ListItemButton selected={match != null} sx={{ paddingLeft: '12px', zIndex: 10 }}>
            <ListItemIcon {...({ variant: 'menuIcon' } as any)} sx={{ paddingRight: '14px', paddingBottom: '1px' }}>
              {props.menuItem.icon || <ArrowRight />}
            </ListItemIcon>
            <ListItemText primary={props.menuItem.description} />
          </ListItemButton>
        </Link>
      </span>
    </Tooltip>
  )
}
